import Footer from "../components/Footer";
import Heading from "../components/Heading";
import Layout from "../components/Layout";
import ProjectList from "../components/ProjectList";
import classNames from "classnames/bind";
import { getPageData } from "../utils/data";
import gridStyle from "../components/Grid.module.css";
import styles from "./ProjectListPage.module.css";
import { useState } from "react";

export default function ProjectListPage({ coreData, pageData, pathName }) {
  const [projectPages, setProjectPages] = useState(pageData.childPages);
  const [currentProjectTypeSlug, setCurrentProjectTypeSlug] = useState("");

  const handleClick = async (e) => {
    const projectTypeSlug = e.target.dataset.slug;

    if (projectTypeSlug === currentProjectTypeSlug) {
      setProjectPages(pageData.childPages);
      setCurrentProjectTypeSlug("");
    } else {
      const path = projectTypeSlug
        ? `work/?project_type=${projectTypeSlug}`
        : "work/";
      const filteredPageData = await getPageData(path);
      setProjectPages(filteredPageData.childPages);
      setCurrentProjectTypeSlug(projectTypeSlug);
    }
  };
  return (
    <Layout coreData={coreData} theme="light" pathName={pathName}>
      <div className={classNames(styles.introSection, gridStyle.grid)}>
        <Heading className={styles.introHeading}>{pageData.heading}</Heading>
      </div>
      {pageData.projectTypes.length > 0 && (
        <div className={styles.projectTypeButtons}>
          <button
            className={classNames({
              [styles.projectTypeButton]: true,
              [styles.active]: currentProjectTypeSlug === "",
            })}
            onClick={handleClick}
            data-slug=""
          >
            All
          </button>
          {pageData.projectTypes.map((projectType) => {
            return (
              <button
                key={projectType.slug}
                className={classNames({
                  [styles.projectTypeButton]: true,
                  [styles.active]: projectType.slug === currentProjectTypeSlug,
                })}
                onClick={handleClick}
                data-slug={projectType.slug}
              >
                {projectType.name}
              </button>
            );
          })}
        </div>
      )}

      <ProjectList
        className={styles.projectList}
        projectPages={projectPages}
        imageBackgroundColor="var(--off-light)"
      />
      <Footer theme="light" />
    </Layout>
  );
}
